<template>
    <div class="table-list">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" summary="조제/배송 내역"
               class="consult-tel-list">
            <caption style="display: none;">조제/배송 내역</caption>
            <colgroup>
                <col width="10%">
                <col width="10%">
                <col width="10%">
                <col width="*%">
                <col v-if="is_admin" width="10%">
                <col width="10%">
                <col width="7%">
                <col width="10%">
                <col width="10%">
                <col width="7%">
                <col width="7%">
            </colgroup>
            <thead>
            <tr>
                <th>접수일시</th>
                <th>완료(취소)일시</th>
                <th>고객명</th>
                <th>병원</th>
                <th v-if="is_admin">약국</th>
                <th>구분</th>
                <th>청구액</th>
                <th>택배사</th>
                <th>송장번호</th>
                <th>신청시기</th>
                <th>상태</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="note in notes" :class="{'on': (note.note_id == current_note_id)}" @click="chosen_row(note)" @dblclick="dblclick_row(note)" :key="note.note_id">
                <td>
                    {{ note.created_at | date_format('YYYY-MM-DD (dd) HH:mm') }}
                </td>
                <td v-if="note.completed_at=='-'">
                    {{ note.completed_at }}
                </td>
                <td v-else>
                    {{ note.completed_at | date_format('YYYY-MM-DD (dd) HH:mm') }}
                </td>
                <td>{{ note.nickname }}</td>                
                <td>
                    <p class="user-name">{{ note.dr_name }}</p>
                </td>
                <td v-if="is_admin">
                    <p class="user-name">{{ note.pharm_name }}</p>
                </td>
                
                <td>
                  <!-- {{ note.pharm_type }} -->
                  {{ note.delivery_type_name }} <span v-if="note.delivery_type == '1'">({{ note.pharmacy_type_name }})</span>
                </td>
                <td>{{ (note.pharmacy_price ? note.pharmacy_price:0) | price_format }}원</td>
                
                <td v-if="note.delivery_type == '1'">
                  {{ note.courier }}
                </td>
                <td v-else-if="note.delivery_type == '2'">
                  {{ note.book_id ? '두발히어로' : ''}}
                </td>
                <td v-else-if="note.delivery_type == '3'">
                  <!-- 퀵배송 -->
                </td>

                <td v-if="note.delivery_type == '1'">
                    {{ note.delivery_no ? note.delivery_no : ''}}
                    <span v-if="note.delivery_no" class="col_button"><input type="button" id="status_img" name="status_img" value="추적" @click="popup_courier(note.courier_url)"></span>
                </td>
                <td v-else-if="note.delivery_type == '2'">
                    {{ note.book_id ? note.book_id : ''}}
                    <span v-if="note.book_id" class="col_button"><input type="button" id="status_img" name="status_img" value="추적" @click="popup_courier(note.courier_url)"></span>
                </td>
                <td v-else-if="note.delivery_type == '3'">

                </td>
                <td>{{ note.apply_type==1 ? '사전' : '사후' }}</td>
                <td>{{ note.status_name }}</td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { nameByConstMixin } from '@/lib/mixins'

export default {
    mixins: [ nameByConstMixin ],
    name: 'consult-pharm-list',
    props: ['notes', 'is_click', 'is_admin'],
    data () {
      return {
        chk_chosen: false,
        current_note_id: 0
      }
    },
    // filters: {
    //     currency: function (value) {
    //         var num = new Number(value);
    //         return num.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
    //     }
    // },
    computed: {
        ...mapState(['account'])
    },
    methods: {
        chosen_row (note) {
            this.current_note_id = note.note_id;
            // this.current_note = note;
            // this.$emit('onSelectRow', note.note_id);
            this.$emit('onSelectRow', note);
            // if(this.is_mobile() && this.chk_chosen) this.popup_detail(note.note_id);
            // this.chk_chosen = true;
            this.$emit('setClick', false);
        },
        dblclick_row (note) {
            // if(this.chk_chosen) 
            // this.popup_detail(note);
            return;
        },
        set_substr(str, str_len) {
            if(str && str.length>str_len) str = str.substr(0,str_len) + "...";
            return str;
        },
        popup_detail(note) {
            // let routeData = this.$router.resolve(`/consulttel_popup/${note.note_id}`);
            let routeData = this.$router.resolve({path:`/consulttel_popup/${note.note_id}`, params:{status: note.status, consult_price_items: note.consult_price_items}});
            this.popupCenter(routeData.href, "tel_detail", 600, 800, 0, 200);
        },
        popup_courier(url) {
            // alert(url)
            this.popupCenter(url, "popup_courier", 600, 800, 0, 200);
        },
    },
    updated() {
        this.$nextTick(function () {
            // if(!this.chk_chosen && this.notes[0]) {
            // console.log("[ConsultTelList]nextTick is_click = ", this.is_click);
            if(this.is_click && this.notes[0]) {
                this.chosen_row(this.notes[0]) // 모든 화면이 렌더링된 후 실행합니다.
            }
            // this.$emit('setClick', true);    // 상태변경 후 첫 줄로 올라가서 삭제함
        })
    },
    mounted() {
    },
  }
</script>

<style scoped>
    .consult-tel-list thead {
        width: 100%;
        height: px;
        border-bottom: 1px solid #e7e7e9;
    }

    .consult-tel-list thead th {
        color: #b8b8b8;
        font: 500 13px/40px 'Noto Sans KR', sans-serif;
    }

    .consult-tel-list tbody tr {
        height: 35px;
        background-color: #fff;
        cursor: pointer;
        border-bottom: 1px solid #e7e7e9;
    }

    .consult-tel-list tbody tr:hover,
    .consult-tel-list tbody tr.on {
        background-color: #f5f6fa;
    }

    .consult-tel-list tbody td {
        text-align: center;
        vertical-align: middle;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .consult-tel-list tbody td:nth-of-type(3) {
        color: #b0b0b0;
    }

    /* 사용자 이름 */
    /*.consult-tel-list tbody td .user-img {*/
        /*float: left;*/
        /*margin-left: 15px;*/
        /*border-radius: 50%;*/
    /*}*/

    .consult-tel-list tbody td .user-name {
        float: left;
        text-align: left;
        overflow: hidden;
        /* width: 120px; */
        height: 40px;
        line-height: 40px;
        margin-right: 15px;
        padding-left: 10px;
    }

    .consult-tel-list tbody td .note-comment {
        float: left;
        text-align: left;
    }    

    .user-img-wrap {
        display: inline-block;
        float: left;
        width: 50px;
        height: 50px;
        border-radius: 50%;
        background-color: #ccc;
        font-size: 10px;
        /*display: block;*/
        border-radius: 50%;
        background-image: url('../../assets/home/profile-default.jpg');
        background-size: 100%
    }

    .user-img-wrap img {
        width: 100%
    }

    .consult-enter {
        text-align: center;
        vertical-align: middle;
    }

    .col_button {
        width:60px;
        height:30px;
        padding: 5px;
    }

    .col_button input {
        line-height:20px;
        background:#5e71e9;
        color:#fff;
        padding:0;
        margin:0;
        border:0;
        cursor: pointer;
        padding: 5px 5px;    
        font: 400 10px 'Noto Sans KR', sans-serif;
        
            
    }

</style>